import { render } from "./RegistrierenSchluesseloch.vue?vue&type=template&id=30b94f48"
import script from "./RegistrierenSchluesseloch.vue?vue&type=script&lang=js"
export * from "./RegistrierenSchluesseloch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__